<template>
  <div class="card-newsle">
    <PuzzlesEmoji />
  </div>
</template>

<script>
  import PuzzlesEmoji from '@/pages/PuzzlesEmoji.vue';

  export default {
    components: {
      PuzzlesEmoji,
    },

    mounted () {
      setTimeout(() => {
        this.$emit('swiperUpdate');
      }, 300)
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';
</style>